import { useState, useEffect } from 'react';

export const Preloader = ({ onFinish }) => {
  const [phase, setPhase] = useState('enter');

  useEffect(() => {
    const enterTimer = setTimeout(() => setPhase('exit'), 2000);
    const finishTimer = setTimeout(() => onFinish(), 2700);
    return () => {
      clearTimeout(enterTimer);
      clearTimeout(finishTimer);
    };
  }, [onFinish]);

  return (
    <div
      className={`fixed inset-0 z-[9999] flex flex-col items-center justify-center bg-white/70 backdrop-blur-2xl transition-all duration-700 ${
        phase === 'exit' ? 'opacity-0 scale-105 pointer-events-none' : 'opacity-100 scale-100'
      }`}
    >
      {/* Glass overlay */}
      <div className="absolute inset-0 bg-gradient-to-br from-brand-50/10 to-transparent pointer-events-none" />

      {/* Outer ring */}
      <div className="relative flex items-center justify-center">
        <div className="absolute w-24 h-24 border border-brand-300/40 rounded-full animate-[preloader-ring_3s_ease-in-out_infinite]" />
        <div className="absolute w-20 h-20 border-2 border-transparent border-t-brand-600 rounded-full animate-spin" style={{ animationDuration: '1.2s' }} />
        <div className="absolute w-14 h-14 border border-transparent border-t-brand-400 rounded-full animate-spin" style={{ animationDuration: '0.8s', animationDirection: 'reverse' }} />
        <img src="/images/logo/favicon/web-app-manifest-512x512.png" alt="" className="w-auto h-12 animate-pulse" style={{ animationDuration: '1.5s' }} />
      </div>

      {/* Brand name */}
      <div className="mt-10 text-center">
        <h1
          className="text-4xl sm:text-5xl font-heading font-bold tracking-tight text-brand-700"
          style={{
            opacity: phase === 'enter' ? 1 : 0,
            transition: 'opacity 0.5s ease',
          }}
        >
          AASHI <span className="text-brand-500">CONSTRUCTIONS</span>
        </h1>
        <p
          className="mt-3 text-sm tracking-[0.2em] uppercase text-brand-400/80"
        >
          Building Excellence
        </p>
      </div>

      {/* Loading bar */}
      <div className="mt-10 w-48 h-[2px] rounded-full overflow-hidden bg-brand-200/60">
        <div
          className="h-full rounded-full bg-brand-600 animate-[preloader-bar_2s_ease-in-out_infinite]"
        />
      </div>
    </div>
  );
};
